export {
  Tabs,
  TabsSize,
  type TabByType,
} from './Tabs';
